import React from 'react';
import { Box, Typography } from '@mui/material';

interface FormLoadingOverlayProps {
  text?: string;
}

const HEADER_HEIGHT = 108;
const FOOTER_HEIGHT = 0;

const FormLoadingOverlay: React.FC<FormLoadingOverlayProps> = ({
  text = 'Loading listing...',
}) => {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: HEADER_HEIGHT,
        left: 0,
        right: 0,
        bottom: FOOTER_HEIGHT,
        bgcolor: 'background.paper',
        zIndex: 1200,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        px: 4,
      }}
    >
      <Box sx={{ width: '100%', maxWidth: 600 }}>
        <Typography
          variant="h6"
          sx={{
            mb: 3,
            textAlign: 'center',
            color: 'text.primary',
          }}
        >
          {text}
        </Typography>
      </Box>
    </Box>
  );
};

export default FormLoadingOverlay;
